import './bootstrap';
import './select-field';
//closing a promo banner: writes the 24 hour dismissal cookie the server reads on the next
//page, then eases the bar off. One delegated listener, so a banner arriving with a change
//of spa is closable too. Without it the close button is inert and the banner stays
import './promo-banner';
import './promo-modals';
//the 12 Weeks of Christmas boxes swing when touched and finish the swing even if the pointer
//leaves, which :hover alone cannot do. Delegated, so nothing attaches per box
import './twelve-weeks-of-christmas';
import './availability-calendar';
//conditional blocks on the pre-arrival check-in questionnaire. Reveal/hide only - the
//server validates, so this never gates the submit
import './checkin/conditionals';
//the rebooking funnel's immediate feedback: an answer that rules the booking out of being
//amended online says so on change, rather than after the customer has also found a voucher
//number. Reveal/hide only - the submit applies the same rules from the same server-side
//RebookingEligibility, so the page works without this
import './rebooking/funnel';
//the rebooking date/time step. Fetches the SAME urls the no-script path uses and swaps the
//server-rendered region in, so there is no second implementation of "what can this customer
//book" - which is how V1's picker came to offer times its own submit would refuse
import './rebooking/times';
//the confirmation page's auto-return countdown, on internal terminals only. The server
//decides who gets the form at all, so this finds nothing on a customer's page. Reveals
//its own copy and submits the form - the page's visible exit button works without it
import './checkout/auto-return';
//the same money formatting <x-price> does on the server, so a total written by
//this script cannot change shape from the one rendered into the page
import { formatPrice } from './shared/formatPrice.js';
//the monetary voucher form's Add to Basket. The same store and the same panel the
//Vue islands use, so the header count and the basket drawer behave identically
//however an item got there
import { state as basketState, addMonetaryVoucherToBasket, isBasketConfigured } from './shared/basketStore.js';
import { openBasketPanel } from './shared/basketPanel.js';
//setup that has to run again when the page's CONTENT is replaced without a reload - the
//homepage's spa picker does that (docs/homepage-location-swap.md). Everything in this file
//that FINDS elements and acts on each of them goes through onContentReady instead of
//DOMContentLoaded; the many handlers delegated from the document need nothing, which is
//why they were written that way
import { onContentReady, onContentReplacing } from './shared/contentLifecycle.js';

console.log("app.js loaded");

const mobileMaxWidth = 767;
const html = document.documentElement;
const body = document.body;

//mobile screen size detect
window.isMobile = (window.innerWidth <= mobileMaxWidth);

window.csrfToken = () =>
{
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}

const preventBodyScroll = () =>
{
    body.classList.add('noscroll');
}
const allowBodyScroll = () =>
{
    body.classList.remove('noscroll');
}

window.stripTags = (html) =>
{
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}

//Modals
window.showModal = function(modal_id)
{
    const modal = document.querySelector("#modals_container .modal[data-modal-id=\""+modal_id+"\"");
    if (modal)
    {
        modal.classList.add("visible");
        preventBodyScroll();
        modal.dispatchEvent(new Event('show'));
        const focusField = modal.querySelector("[data-focus-on-show-modal]");
        if (focusField)
        {
            focusField.focus();
        }
    }
}

//Gallery lightbox: shows one image full-screen over a dimmed page. A native
//<dialog>, so Esc, focus containment and the ::backdrop come free - styling
//lives in includes/components/lightbox.scss. Built once, on first use, and
//opened from any [data-lightbox] link via the delegated click handler below.
window.openLightbox = function(src, alt = '')
{
    let lightbox = document.querySelector('dialog.lightbox');
    if (!lightbox)
    {
        lightbox = document.createElement('dialog');
        lightbox.className = 'lightbox';
        lightbox.innerHTML = '<button type="button" class="lightbox_close plain" aria-label="Close">&times;</button><img alt="" />';

        //close() removes the dialog from the top layer instantly, so the fade
        //out has to finish first: the closing class runs the animation and the
        //real close follows. The timeout must stay in step with the animation
        //duration in components/lightbox.scss
        const closeLightbox = () => {
            if (lightbox.classList.contains('closing'))
            {
                return;
            }
            lightbox.classList.add('closing');
            setTimeout(() => {
                lightbox.classList.remove('closing');
                lightbox.close();
            }, 250);
        };

        //clicks on the ::backdrop register on the dialog element itself, so
        //this closes on the backdrop or the button, but never on the image
        lightbox.addEventListener('click', (event) => {
            if (event.target === lightbox || event.target.closest('.lightbox_close'))
            {
                closeLightbox();
            }
        });

        //Esc fires cancel; hold it back so it fades like the other routes
        lightbox.addEventListener('cancel', (event) => {
            event.preventDefault();
            closeLightbox();
        });

        //fires on every close route (button, backdrop, Esc), so the scroll
        //lock cannot leak - same preventBodyScroll pairing the modals use
        lightbox.addEventListener('close', allowBodyScroll);

        document.body.appendChild(lightbox);
    }

    const image = lightbox.querySelector('img');
    image.src = src;
    image.alt = alt;
    preventBodyScroll();
    lightbox.showModal();
}

window.hideModal = function(modal_id = null)
{
    let modals, modal_to_close;
    if (modal_id!==null)
    {
        modal_to_close = document.querySelectorAll("#modals_container .modal[data-modal-id=\""+modal_id+"\"");
    }
    else
    {
        modals = document.querySelectorAll("#modals_container .modal");

        for (let modal of modals)
        {
            const rect = modal.getBoundingClientRect();

            // Check the center point of the modal
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            const topElement = document.elementFromPoint(centerX, centerY);

            // Check if the modal is the topmost at its own center
            if (modal.contains(topElement) || modal === topElement)
            {
                modal_to_close = modal;
            }
        }
    }
    modal_to_close.classList.remove("visible");
    modal_to_close.dispatchEvent(new Event('hide'));

    // Only release the body scroll lock once no modals remain open, so
    // closing one modal that sits over another keeps the lock in place.
    if (!document.querySelector("#modals_container .modal.visible"))
    {
        allowBodyScroll();
    }
}

window.modal = function(content,title = null, rich = false)
{
    const dynamic_modal = document.querySelector("#modals_container .modal[data-modal-id=\"dynamic\"]");
    if (!rich)
    {
        content = "<p>"+content+"</p>";
    }
    if (title==null)
    {
        title = "Message";
    }
    dynamic_modal.querySelector(".modal_header > h4 > span").innerHTML = title;
    dynamic_modal.querySelector(".modal_content").innerHTML = content;
    window.showModal('dynamic');
}

window.richModal = function(content,title = null)
{
    window.modal(content,title,true);
}

//Pop-out panels
//
// Every panel this system owns is identified by its data-pop-out-panel-id, and each
// handler below refuses to act on a .pop_out_panel without one. That attribute is
// therefore the sole discovery key, not the class.
//
// The reason: PopOutPanel.vue (the Vue twin, see docs/blade-to-vue-components.md)
// renders the same classes on purpose - they are the shared styling contract - but
// manages its own open/close state reactively. Without these guards this script would
// find Vue's panels by class and act on them behind Vue's back, which is how the
// select-field port broke (a page-wide DOMContentLoaded sweep adopting Vue markup;
// built module scripts run before DOMContentLoaded fires). Vue panels carry no id, so
// the two systems share the stylesheet and nothing else.
window.showPopOutPanel = function(panel_id)
{
    const panel = document.querySelector(".pop_out_panel[data-pop-out-panel-id=\""+panel_id+"\"]");
    const overlay = document.querySelector(".pop_out_panel_overlay[data-pop-out-panel-overlay=\""+panel_id+"\"]");
    if (panel)
    {
        panel.classList.add("visible");
        overlay?.classList.add("visible");
        preventBodyScroll();
        document.querySelectorAll("[data-pop-out-panel-toggle=\""+panel_id+"\"]").forEach(toggle => {
            toggle.setAttribute('aria-expanded', 'true');
        });
    }
}

window.hidePopOutPanel = function(panel_id)
{
    const panel = document.querySelector(".pop_out_panel[data-pop-out-panel-id=\""+panel_id+"\"]");
    const overlay = document.querySelector(".pop_out_panel_overlay[data-pop-out-panel-overlay=\""+panel_id+"\"]");
    if (panel)
    {
        panel.classList.remove("visible");
        overlay?.classList.remove("visible");
        document.querySelectorAll("[data-pop-out-panel-toggle=\""+panel_id+"\"]").forEach(toggle => {
            toggle.setAttribute('aria-expanded', 'false');
        });
    }

    // Only release the body scroll lock once no pop-out panels remain open.
    //
    // Deliberately *not* narrowed to [data-pop-out-panel-id] like the handlers above:
    // this must count Vue-rendered panels too, or closing the hamburger menu would
    // unlock the page while a Vue panel is still open. panelStack.js applies the same
    // guard in reverse. A read-only check across both systems is the point here.
    if (!document.querySelector(".pop_out_panel.visible"))
    {
        allowBodyScroll();
    }
}

// Toggles .stuck on a panel's footer while it is pinned to the panel's bottom
// edge, so its solid fill appears only when content is passing beneath it and the
// footer's text would otherwise be illegible. CSS cannot detect this - there is
// no :stuck pseudo-class.
//
// Measured rather than inferred from a sentinel: a bottom: 0 sticky element is
// pinned exactly when its bottom edge has been pushed to the container's bottom
// edge, which is directly comparable. Sentinel-and-IntersectionObserver
// approaches have to approximate this and get the edge cases wrong.
// The teardown handle for each observed panel, so the listeners below can be removed when
// the panel's markup is replaced without a page load.
//
// This exists because the observer attaches a listener to WINDOW, which outlives the panel
// it is measuring. Before the content swap (docs/homepage-location-swap.md) that could not
// leak: the sweep ran once per page load and every listener died with the document. Now a
// homepage carrying a Facilities section observes one panel per facility, and every swap
// would otherwise add a fresh set that keeps the detached panel alive with it - a customer
// comparing five spas would leave five sets behind.
//
// Weak, so a panel dropped without a swap (a section removing its own markup) takes its
// entry with it rather than pinning the element here forever.
const panelFooterObservers = new WeakMap();

window.observePopOutPanelFooter = function(panel)
{
    const footer = panel.querySelector(".pop_out_panel_footer");

    if (!footer)
    {
        return;
    }

    //idempotent, as onContentReady requires: a second observer on one panel would measure
    //the same footer twice a frame and fight itself over the class
    if (panelFooterObservers.has(panel))
    {
        return;
    }

    //one signal for both listeners, so forgetting to remove one is not possible
    const observer = new AbortController();
    panelFooterObservers.set(panel, observer);

    let pending = false;

    const update = () => {
        pending = false;

        // 1px of tolerance for sub-pixel layout, which otherwise flickers the
        // class on and off at the boundary.
        const stuck = footer.getBoundingClientRect().bottom >= panel.getBoundingClientRect().bottom - 1;

        footer.classList.toggle("stuck", stuck);
    };

    // Coalesced to one measurement per frame - scroll fires far more often than
    // the layout can meaningfully change.
    const schedule = () => {
        if (!pending)
        {
            pending = true;
            requestAnimationFrame(update);
        }
    };

    panel.addEventListener("scroll", schedule, { signal: observer.signal });
    window.addEventListener("resize", schedule, { signal: observer.signal });
    update();
}

// Stops measuring one panel and releases its listeners. Called when the panel's markup is
// about to be replaced; safe on a panel that was never observed.
window.unobservePopOutPanelFooter = function(panel)
{
    panelFooterObservers.get(panel)?.abort();
    panelFooterObservers.delete(panel);
}

//Sticky header

// Two variables, both on :root, because two different questions are being asked
// about the same header and answering them with one value causes a visible jump.
//
// --stuck-header-height is the height to compensate for RIGHT NOW: the header's
// height while it is fixed, absent while it is in flow. #page_header's own padding
// wants exactly this, since the space only needs reserving while the header has
// left the flow (header.scss).
//
// --header-height is the header's height FULL STOP, set once the header has been
// measured and left alone thereafter. Anything positioning itself to clear the
// header wants this one - a sticky element offsetting by the first variable would
// shift by the header's whole height at the moment it sticks, which reads as a
// jump (the checkout summary column did exactly that - see pages/checkout.scss).
//
// Published on :root rather than the header because custom properties inherit: set
// on #page_header they are invisible to anything outside its subtree, which is
// where every consumer other than the header itself lives.
const setHeaderHeight = function(height)
{
    document.documentElement.style.setProperty("--header-height", height + "px");
}

// Cleared rather than zeroed when the header releases, so the consumers' own
// var(--stuck-header-height, 0px) fallbacks apply and there is one definition of
// "not stuck" instead of two.
const setStuckHeaderHeight = function(height)
{
    if (height === null)
    {
        document.documentElement.style.removeProperty("--stuck-header-height");
        return;
    }

    document.documentElement.style.setProperty("--stuck-header-height", height + "px");
}

// Fixes #page_header's .sticky_header to the top of the viewport once the page has
// scrolled past --sticky-header-offset, which is set far enough to clear the search
// bar on the pages that carry one.
//
// A single scroll distance rather than observing the search bar itself: the bar only
// renders on pages using @section('show_search_bar'), so a sentinel-based approach
// would need a second, separate behaviour for every other page.
window.observeStickyHeader = function()
{
    const header = document.getElementById("page_header");
    const sticky = header ? header.querySelector(".sticky_header") : null;

    if (!sticky)
    {
        return;
    }

    // Published before the first scroll, while the header is still in flow, so
    // anything offsetting itself by the header clears it from the very first paint
    // rather than snapping into place the moment the header first sticks.
    setHeaderHeight(sticky.offsetHeight);

    // Read from CSS so the threshold keeps one home - the token in variables.scss.
    //
    // Read on each measurement rather than once at init, because the distance to clear is
    // no longer fixed for the life of the page: since 3 Sep 2026 the search bar renders on
    // every page and starts collapsed on an ordinary one, expanding when the header's
    // Book/Gift/Redeem toggle reveals it. The token is redefined for the collapsed case in
    // header.scss, so reading it live is what lets the threshold follow the reveal. It is
    // a getComputedStyle on one element behind an rAF-throttled handler, and only while
    // the stuck state is actually being evaluated.
    const stickyOffset = () => parseInt(getComputedStyle(header).getPropertyValue("--sticky-header-offset"), 10) || 160;

    // How far down the document the header actually starts.
    //
    // --sticky-header-offset is a distance to scroll, measured as though the header began at
    // the very top of the page. Anything rendered ABOVE it pushes it down by its own height,
    // so the scroll position at which the header has genuinely cleared the viewport is that
    // much further on. Two things sit up there and either may be absent: the MOTO banner
    // (staff only) and the promo banners (scheduled, and per spa).
    //
    // Without this the header pins too early: on a page with a banner it would fix itself to
    // the top of the viewport while the real header was still on screen below, so the header
    // vanished mid-scroll instead of appearing to drop back down after scrolling away. Worst
    // on a phone, where the banners are proportionally tallest.
    //
    // offsetTop rather than adding up the banners' heights: it answers the question directly,
    // needs no list of what might be above the header, and stays right if something else is
    // ever added up there. Read live rather than cached at init - a banner can be dismissed,
    // and the promo region's height changes when the customer switches spa
    // (resources/js/shared/pageSwap.js).
    //
    // offsetTop is relative to the nearest positioned ancestor. #page_header's ancestors up to
    // <body> are all static, so this is the document-top distance it looks like. A positioned
    // wrapper introduced around the header would break that quietly, which is what the
    // regression test in tests/Feature/View/StickyHeaderOffsetTest.php pins.
    //
    // Measured on #page_header, NOT on the .sticky_header inside it. Only the inner element
    // takes position: fixed, so the outer one stays in flow and keeps reporting the true
    // in-flow distance even while the header is pinned - which is what makes this usable for
    // the release threshold as well as the pin one. Measuring the fixed element would give 0
    // once stuck, and the header would never release.
    const headerTop = () => header.offsetTop;

    // The scroll position at which unsticking moves the header nowhere: in flow it sits
    // #page_header's top padding below the document top, whereas fixed it sits at
    // top: 0, so the two coincide once the page has scrolled by exactly that padding.
    // Releasing at 0 instead would drop it by the padding's height.
    //
    // Measured rather than read from --half-gutter, which computes to the string
    // "calc(15px / 2)" and cannot be parsed as a pixel value - and measured here at
    // init, while the header is still in flow, because once it is fixed this padding
    // also carries the reserved --stuck-header-height.
    const releaseOffset = parseFloat(getComputedStyle(header).paddingTop) || 0;

    let pending = false;

    // Scroll position at the previous measurement, so update() can tell which way the
    // page is moving. Direction matters because sticking on the way up needs to happen
    // without the entry slide - see where this is read below.
    let lastScrollY = window.scrollY;

    // $animate is false for the very first measurement, so a page loaded already
    // scrolled past the threshold starts with the header simply in place rather
    // than sliding it in over content the visitor has not scrolled to yet.
    const update = (animate = true) => {
        pending = false;

        // Captured before the early return below, so it stays accurate either way.
        const scrollingDown = window.scrollY > lastScrollY;
        lastScrollY = window.scrollY;

        const wasStuck = sticky.classList.contains("stuck");

        // Asymmetric on purpose: it takes --sticky-header-offset of scrolling to pin
        // the header, but once pinned it stays put until the page is all but back at
        // the top. Releasing at the same offset instead would drop the header back
        // into flow mid-scroll, part-way up a page the visitor is still moving
        // through.
        //
        // Coming back up it releases at releaseOffset, the one position where fixed and
        // in-flow put the header in the same place, so the swap is invisible.
        // Both thresholds are shifted by whatever sits above the header, so a banner moves the
        // whole behaviour down the page rather than only the pinning half. Releasing at the
        // unshifted position would drop the header back into flow while the banners were still
        // scrolled off, which is the same mismatch in the other direction.
        const above = headerTop();

        const stuck = wasStuck
            ? window.scrollY > above + releaseOffset
            : window.scrollY > above + stickyOffset();

        // Nothing below needs doing unless the state is actually changing, which
        // also keeps the slide keyed to the transition rather than re-firing on
        // every scroll frame while stuck.
        if (stuck === wasStuck)
        {
            return;
        }

        if (stuck)
        {
            // Measured while the header is still in flow - once it is fixed, its
            // height is the very thing being compensated for, and the padding it
            // sets would feed back into the next measurement.
            //
            // Set on :root, not on the header: custom properties inherit, so on the
            // header it is only visible to the header's own subtree. Anything else
            // on the page that has to clear the fixed header - a sticky column
            // beside the content, say - sits outside that subtree and would read
            // only the fallback.
            setStuckHeaderHeight(sticky.offsetHeight);
            header.classList.add("has_stuck_header");
            sticky.classList.add("stuck");

            // .stuck fixes the header off-screen above the viewport; .stuck_in carries
            // the transition that slides it down and fades its fill up. These must land
            // in a later frame than .stuck: the off-screen transform has to be rendered
            // before the transition exists, or there is no start position to travel
            // from.
            //
            // A forced style flush (void offsetHeight) is not enough. It resolves the
            // computed value, but the transform still has to be *rendered* at -100%
            // before the transition is introduced - so this needs a real frame
            // boundary, which is what rAF provides here.
            //
            // Only slide when the visitor is heading down the page. Sticking also
            // happens on the way *up* - out of the top of the sticky zone towards the
            // top of the page - and sliding in then is actively wrong: the header
            // starts off-screen and travels down while the page is travelling up, so
            // it reads as the header rising too high and dropping back into place.
            if (animate && scrollingDown)
            {
                requestAnimationFrame(() => sticky.classList.add("stuck_in"));
            }
            else
            {
                sticky.classList.add("stuck_in");
            }

            return;
        }

        // Releasing. Everything comes off at once and the fill vanishes with it - no
        // fade out. Holding the header fixed long enough to fade meant it stayed put
        // while the page carried on scrolling beneath it, which read as the header
        // hanging too high and then dropping into place.
        sticky.classList.remove("stuck", "stuck_in");
        header.classList.remove("has_stuck_header");

        // The reserved height goes with the fixed state. Harmless to leave behind
        // while only #page_header read it (its padding comes off with
        // .has_stuck_header regardless), but a consumer keyed off the variable
        // alone would otherwise stay offset by a header that is back in flow.
        setStuckHeaderHeight(null);
    };

    // Coalesced to one measurement per frame - scroll fires far more often than
    // the layout can meaningfully change. update() is called explicitly rather
    // than passed by reference, so rAF's frame timestamp can't arrive as $animate.
    const schedule = () => {
        if (!pending)
        {
            pending = true;
            requestAnimationFrame(() => update());
        }
    };

    window.addEventListener("scroll", schedule, { passive: true });

    // A resize can change the header's height while it is stuck, and update()
    // deliberately returns early when the stuck state itself hasn't changed - so
    // the reserved height is refreshed here instead. A fixed element's own height
    // is still its rendered height, and the reserved padding sits on #page_header
    // rather than inside the header, so this measures cleanly without having to
    // unstick it first.
    window.addEventListener("resize", () => {
        // Unconditional, unlike the reserved height below: --header-height describes
        // the header at any moment, stuck or not, so a breakpoint change has to be
        // picked up either way.
        setHeaderHeight(sticky.offsetHeight);

        if (sticky.classList.contains("stuck"))
        {
            setStuckHeaderHeight(sticky.offsetHeight);
        }

        schedule();
    });

    // No slide on the first measurement - see update().
    update(false);
}

//Form cards

// Resolves the element that currently speaks for a card: the selected option of a
// <select>, or a checked input, rather than simply the first element carrying the
// attribute - every <option> in a select carries it, so a plain querySelector
// would always report the first one regardless of what is chosen.
const selectedFormCardSource = function(card)
{
    const select = card.querySelector('select');

    if (select && select.selectedOptions.length)
    {
        return select.selectedOptions[0];
    }

    return card.querySelector('input:checked[data-selected-title]')
        ?? card.querySelector('[data-selected-title]');
}

// Complete a form card: carry the chosen values up into the collapsed title and
// summary, then collapse it. Values come from whichever field in the card carries
// data-selected-title (and optionally data-selected-summary), so the card's own
// markup decides what speaks for it and the component needs no configuration.
// Attributes that aren't present leave the server-rendered text alone.
window.confirmFormCard = function(card)
{
    const source = selectedFormCardSource(card);

    if (source)
    {
        const title = source.getAttribute('data-selected-title');
        const summary = source.getAttribute('data-selected-summary');

        if (title !== null)
        {
            const titleElement = card.querySelector('.form_card_completed_title');
            if (titleElement)
            {
                titleElement.textContent = title;
            }
        }

        if (summary !== null)
        {
            const summaryElement = card.querySelector('.form_card_summary');
            if (summaryElement)
            {
                summaryElement.textContent = summary;
            }
        }
    }

    card.classList.add('completed');

    // Advance to the next stage still needing an answer, skipping any already
    // completed - so a fresh booking steps forward, while re-confirming an
    // earlier stage of a finished one doesn't reopen a later stage the user has
    // already settled. Nothing opens if every later card is complete.
    //
    // Cards not marked .completed are already open (form-card.scss keys the open
    // state off :not(.completed)), so reaching one is the whole job - there is no
    // class to add. Scrolled into view because a collapsing card above it can
    // move it, and on a short panel it may sit below the fold.
    //
    // Narrowed to [data-form-card] so a Vue-rendered card sharing the class hooks
    // is never scrolled by this script - Vue owns which of its own stages is open.
    let next = card.nextElementSibling;

    while (next)
    {
        if (next.matches('.form_card[data-form-card]') && !next.classList.contains('completed'))
        {
            next.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            return;
        }

        next = next.nextElementSibling;
    }
}

//lazy load

window.fadeLazyLoadImage = function (image)
{
    //idempotent, as onContentReady requires and as Vue's function refs need: a second
    //call would attach a second load listener and decode the same image twice. The marker
    //is an attribute rather than the .loaded class, because the class only appears AFTER
    //the image loads - a below-the-fold lazy image is legitimately marked and not yet
    //loaded, and testing the class would re-listen to it on every swap.
    if (image.dataset.lazyFading === 'true')
    {
        return;
    }

    image.dataset.lazyFading = 'true';

    if (image.complete)
    {
        // If the image is already loaded from cache, add loaded class immediately
        image.classList.add("loaded");
    }
    else
    {
        image.addEventListener("load", () =>
        {
            image.decode().then(() => {
                image.classList.add("loaded");
            }).catch(() => {
                // If something went wrong, add loaded class anyway
                image.classList.add("loaded");
            });
        });
    }
}

// Contact Details section type: the Map button slides a Google map down below the
// address (resources/views/section-types/contact-details.blade.php, and
// includes/section-types/contact-details.scss for the animation).
//
// Three jobs, in this order:
//
// 1. Swap data-map-src into the iframe's src, but only on the FIRST open. The view
//    ships the iframe with no src precisely so that a page nobody opens the map on
//    never contacts Google, so this is the request actually happening - and it must
//    not happen again on every subsequent toggle, which would reload the map and
//    throw away the visitor's panning and zooming.
//
// 2. Toggle .open, which is what the stylesheet animates (grid-template-rows).
//
// 3. Keep aria-expanded on the toggle in step, and inert + aria-hidden on the
//    closed panel. Without inert, a keyboard user tabs into a map they cannot see:
//    the panel is only clipped by overflow: hidden, so its contents stay focusable.
//    The CSS reads the chevron's direction from aria-expanded, so setting it here is
//    what rotates the arrow too - there is no separate class for that.
window.toggleContactDetailsMap = function(map_id)
{
    const map = document.querySelector('[data-contact-map]#' + CSS.escape(map_id));

    if (!map)
    {
        return;
    }

    const opening = !map.classList.contains("open");

    if (opening)
    {
        //first open only - see (1) above
        const iframe = map.querySelector("iframe[data-map-src]");
        if (iframe && !iframe.getAttribute("src"))
        {
            iframe.setAttribute("src", iframe.getAttribute("data-map-src"));
        }
    }

    map.classList.toggle("open", opening);

    //inert is removed before the slide-in and applied after the slide-out, so focus
    //is never trapped in a panel mid-animation. The attribute rather than the
    //property, to match the rest of this file.
    if (opening)
    {
        map.removeAttribute("inert");
        map.removeAttribute("aria-hidden");
    }
    else
    {
        map.setAttribute("inert", "");
        map.setAttribute("aria-hidden", "true");
    }

    document.querySelectorAll('[data-contact-map-toggle="' + map_id + '"]').forEach(toggle => {
        toggle.setAttribute("aria-expanded", opening ? "true" : "false");
    });
}

//Quantity steppers (<x-quantity-input>)
//
//Steps the number field inside the same [data-quantity-input] wrapper as the
//button that was pressed. Generic on purpose - it knows nothing about what the
//field counts, so any consumer gets working +/- buttons by rendering the
//component, and the component needs no script of its own.
//
//The buttons exist because the site's form reset hides the browser's own number
//spinners (includes/form.scss), so this is the only pointer route to changing a
//number on the site.
window.stepQuantityInput = function(button)
{
    const wrapper = button.closest("[data-quantity-input]");
    const field = wrapper?.querySelector('input[type="number"]');

    if (!field)
    {
        return;
    }

    //the field's own attributes are the bounds, not values passed to this
    //function - the markup already states them for native validation and the
    //keyboard's arrow keys, and a second copy could disagree with them
    const min = field.min === "" ? 0 : Number(field.min);
    const max = field.max === "" ? null : Number(field.max);
    const step = Number(button.getAttribute("data-quantity-step")) || 0;

    //a cleared or half-typed field reads as NaN. The minimum is where the field
    //started, so it is the sane place to resume from
    const current = Number.isNaN(field.valueAsNumber) ? min : field.valueAsNumber;

    let next = Math.max(min, current + step);

    if (max !== null)
    {
        next = Math.min(max, next);
    }

    if (next === current)
    {
        //already at the end of the range - nothing changed, so nothing is
        //announced. Firing anyway would have consumers recalculating on every
        //click of a button that cannot do anything
        return;
    }

    field.value = next;

    //`input` rather than `change`, and bubbling, so a delegated listener on an
    //ancestor sees a button press and a keystroke as the same event - which is
    //what keeps consumers from needing to know this component exists
    field.dispatchEvent(new Event("input", { bubbles: true }));
}

//Monetary voucher form total (section-types/monetary-voucher-form.blade.php)
//
//amount x quantity. Formatted through the shared formatPrice so the figure keeps
//the shape <x-price> gave it on first render - pence only when they are non-zero.
window.updateVoucherFormTotal = function(form)
{
    const amountField = form.querySelector("[data-voucher-amount]");
    const quantityField = form.querySelector('[data-voucher-quantity] input[type="number"]');
    const output = form.querySelector("[data-voucher-total]");

    if (!amountField || !output)
    {
        return;
    }

    const amount = Number(amountField.value);
    //no stepper in the form means one of whatever was chosen
    const quantity = quantityField ? Number(quantityField.value) : 1;

    //a cleared or invalid amount has no total to state. The last good figure is
    //left where it is rather than replaced with "£0" or "£NaN", either of which
    //reads as a price rather than as a field mid-edit
    if (Number.isNaN(amount) || Number.isNaN(quantity) || amount <= 0 || quantity <= 0)
    {
        return;
    }

    const total = formatPrice(amount * quantity);

    if (total !== null)
    {
        output.textContent = total;
    }
}

//Setup that acts on each matching ELEMENT, so it has to run again for content that
//arrives later. onContentReady calls these once for the initial page and once per region
//of any content swapped in afterwards (shared/contentLifecycle.js). Both were
//DOMContentLoaded sweeps until the homepage's spa picker started replacing content in
//place: the Facilities section renders a pop-out panel per facility and the Contact
//Details section renders a map, so both of these have real work to do on a swapped page.
//
//Note the `root` scoping. A sweep that ignored it and re-queried the whole document would
//still be correct for these two - both are idempotent - but it would do the work again for
//every element that did not change, and the next person to copy the pattern would inherit
//the habit.
onContentReady((root) => {
    //pop-out panel sticky footers. PopOutPanel.vue runs its own equivalent per instance
    //(with teardown on unmount, which this sweep cannot do), so the attribute selector
    //keeps this off Vue's panels - it would otherwise adopt them, since Vite's module
    //scripts execute before DOMContentLoaded fires.
    root.querySelectorAll(".pop_out_panel[data-pop-out-panel-id]").forEach(window.observePopOutPanelFooter);

    //closed maps start inert. Applied here rather than in the markup to keep the
    //attribute owned by one place - the toggle function above is what maintains it
    //thereafter, and a hardcoded inert in the view would be a second source of truth
    //that a future change to the default state would have to remember. The site
    //assumes JavaScript throughout (there is no noscript handling anywhere in it),
    //so there is no non-JS case for this to get wrong.
    root.querySelectorAll('[data-contact-map]:not(.open)').forEach(map => {
        map.setAttribute('inert', '');
        map.setAttribute('aria-hidden', 'true');
    });

    //lazy loading images fade in. images.scss holds img[loading="lazy"] at opacity: 0
    //until it gains .loaded, so an image this never reaches stays INVISIBLE - which is
    //what happened to every image on a swapped-in homepage while this was still a
    //DOMContentLoaded sweep. The most visible failure of the lot, and the reason the
    //house rule in shared/contentLifecycle.js is worth following without exception:
    //nothing about the markup announces that it depends on a script having run.
    root.querySelectorAll('img[loading="lazy"]').forEach(image => {
        window.fadeLazyLoadImage(image);
    });
});

//Teardown for the two things above that outlive the markup they act on.
//
//Narrowed to [data-pop-out-panel-id] like the other panel handlers here, and for the same
//reason: Vue's panels share the classes but manage their own state, and they live in the
//panel host outside every swapped region anyway.
onContentReplacing((root) => {
    root.querySelectorAll('.pop_out_panel[data-pop-out-panel-id]').forEach(panel => {
        //an OPEN panel would take the body scroll lock with it: hidePopOutPanel() is what
        //releases the lock, and it can only find a panel that is still in the document. So
        //it is closed while it still exists, and the customer is left able to scroll the
        //page they have just been given
        if (panel.classList.contains('visible'))
        {
            window.hidePopOutPanel(panel.getAttribute('data-pop-out-panel-id'));
        }

        //and the footer observer's window listener is released, or every swap would leave
        //one behind per panel
        window.unobservePopOutPanelFooter(panel);
    });
});

document.addEventListener("DOMContentLoaded", () => {

    //mobile screen size detector
    window.addEventListener('resize', () => {
        window.isMobile = (window.innerWidth <= mobileMaxWidth);
    });

    //sticky site header. Stays here rather than moving to onContentReady below: the header
    //is the one thing a content swap never touches, so observing it once is right.
    window.observeStickyHeader();

    //contact details map reveal. Delegated rather than bound per button so a section
    //rendered after this sweep still works, and keyed on the data attribute rather
    //than the class for the same reason the panel handlers above are - the class is a
    //styling hook and may be shared, the attribute is the discovery key.
    document.addEventListener('click', (event) => {
        if (event.target)
        {
            const mapToggle = event.target.closest('[data-contact-map-toggle]');
            if (mapToggle)
            {
                event.preventDefault();
                window.toggleContactDetailsMap(mapToggle.getAttribute('data-contact-map-toggle'));
            }
        }
    });

    //modal show / hide events
    //Opens or closes one hamburger-menu accordion section, keeping .open and
    //aria-expanded in step. Shared by the click and keydown handlers below.
    window.toggleNavAccordion = (toggle) => {
        const navItem = toggle.closest('li.has_children');
        if (!navItem) return;

        const opening = !navItem.classList.contains('open');

        //One open at a time - a phone screen cannot hold two expanded menus without
        //becoming a long scroll. Siblings are closed even when this one is closing,
        //which costs nothing and keeps the markup and the classes from drifting apart.
        navItem.parentNode.querySelectorAll(':scope > li.has_children.open').forEach(sibling => {
            if (sibling === navItem) return;

            sibling.classList.remove('open');
            sibling.querySelectorAll('[data-nav-accordion-toggle]').forEach(siblingToggle => {
                siblingToggle.setAttribute('aria-expanded', 'false');
            });
        });

        navItem.classList.toggle('open', opening);
        toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
    };

    //The accordion toggles are <a role="button"> rather than <button>, so that one
    //`li a` rule in navigation.scss styles every row in the menu the same way. The
    //cost of that choice is paid here: an anchor fires a click on Enter but NOT on
    //Space, which a real <button> would handle itself. Without this, a keyboard user
    //pressing Space on a focused toggle scrolls the panel instead of opening it.
    document.addEventListener('keydown',(event) => {
        if (event.key !== ' ' && event.key !== 'Spacebar') return;

        const navAccordionToggle = event.target.closest?.('[data-nav-accordion-toggle]');
        if (navAccordionToggle)
        {
            event.preventDefault();
            window.toggleNavAccordion(navAccordionToggle);
        }
    });

    document.addEventListener('click',(event) => {
        if (event.target)
        {
            const modalTrigger = event.target.closest('[data-show-modal]');
            if (modalTrigger)
            {
                event.preventDefault();
                window.showModal(modalTrigger.getAttribute('data-show-modal'));
            }

            const popOutPanelToggle = event.target.closest('[data-pop-out-panel-toggle]');
            const togglePanelId = popOutPanelToggle?.getAttribute('data-pop-out-panel-toggle');
            if (togglePanelId)
            {
                event.preventDefault();
                const panel = document.querySelector(".pop_out_panel[data-pop-out-panel-id=\""+togglePanelId+"\"]");
                if (panel && panel.classList.contains('visible'))
                {
                    window.hidePopOutPanel(togglePanelId);
                }
                else
                {
                    window.showPopOutPanel(togglePanelId);
                }
            }

            //hamburger menu accordion (partials/hamburger-navigation.blade.php).
            //Two row shapes reach this: a chevron sitting beside a parent link, and a
            //whole-row toggle where the parent has no page to link to. Both carry the
            //attribute, so neither is special-cased here.
            const navAccordionToggle = event.target.closest('[data-nav-accordion-toggle]');
            if (navAccordionToggle)
            {
                event.preventDefault();
                window.toggleNavAccordion(navAccordionToggle);
            }

            //the id check is what keeps this off Vue-rendered panels, which share the
            //class but not the attribute - see the note above showPopOutPanel()
            const popOutPanelClose = event.target.closest('.pop_out_panel_close');
            const closePanelId = popOutPanelClose?.closest('.pop_out_panel')?.getAttribute('data-pop-out-panel-id');
            if (closePanelId)
            {
                event.preventDefault();
                window.hidePopOutPanel(closePanelId);
            }

            const popOutPanelOverlay = event.target.closest('.pop_out_panel_overlay');
            const overlayPanelId = popOutPanelOverlay?.getAttribute('data-pop-out-panel-overlay');
            if (overlayPanelId)
            {
                window.hidePopOutPanel(overlayPanelId);
            }

            //gallery click-to-zoom: the link's href is the full-size image.
            //no preventDefault where <dialog> is unsupported (Safari <15.4) -
            //the link then navigates to the image, the pre-lightbox behaviour
            const lightboxLink = event.target.closest('a[data-lightbox]');
            if (lightboxLink && window.HTMLDialogElement)
            {
                event.preventDefault();
                window.openLightbox(lightboxLink.getAttribute('href'), lightboxLink.querySelector('img')?.alt || '');
            }

            //gallery "show all" reveal (section-types/gallery.blade.php) -
            //the slide animation itself is CSS (grid-template-rows, gallery.scss),
            //this only flips the class and keeps the button honest
            const galleryToggle = event.target.closest('[data-gallery-toggle]');
            if (galleryToggle)
            {
                event.preventDefault();
                const extra = document.getElementById(galleryToggle.getAttribute('data-gallery-toggle'));
                if (extra)
                {
                    const open = extra.classList.toggle('open');
                    galleryToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
                    //the wording lives in its own span, not on the button: the button
                    //also holds the inline <svg> icon, and writing textContent to it
                    //would delete that icon on the first click and never restore it.
                    //Guarded so a missing span costs the label swap, not the reveal
                    const galleryToggleLabel = galleryToggle.querySelector('[data-gallery-toggle-label]');
                    if (galleryToggleLabel)
                    {
                        galleryToggleLabel.textContent = open ? 'Show fewer' : 'Show all';
                    }
                }
            }

            //reopen a completed form card in place (edit links with an href navigate instead) -
            //the completed class is the card's single state switch, so removing it is the whole job.
            //data-form-card is what keeps this off Vue-rendered cards, which share the class hooks
            //but not the attribute - see the note in components/form-card.blade.php
            const formCardEdit = event.target.closest('[data-form-card-edit]')
                ?.closest('.form_card[data-form-card]');
            if (formCardEdit)
            {
                event.preventDefault();
                formCardEdit.classList.remove('completed');
            }

            //complete a form card from its confirm button - the mirror of the edit
            //control above, which removes the same class. .confirm_button is a styling
            //class as well as this script's only selector for it, so unlike the edit
            //control there is no private attribute to key off: the card's own
            //data-form-card is what separates the two systems here
            const formCardConfirm = event.target.closest('.confirm_button')
                ?.closest('.form_card[data-form-card]');
            if (formCardConfirm)
            {
                event.preventDefault();
                window.confirmFormCard(formCardConfirm);
            }

            //quantity stepper buttons (<x-quantity-input>). preventDefault because
            //these sit inside a form and a stray submit would reload the page
            const quantityStep = event.target.closest('[data-quantity-step]');
            if (quantityStep)
            {
                event.preventDefault();
                window.stepQuantityInput(quantityStep);
            }
        }
    });

    //monetary voucher form: keep the amount field, the presets and the total in
    //agreement. Delegated from the document, like the handlers above, so a section
    //rendered after this sweep still works.
    //
    //Both event types, because the two controls announce themselves differently: a
    //number field fires `input` on every keystroke, a radio fires `change` (and
    //`input` too, in browsers that follow the spec here). The handler is
    //idempotent, so running it twice for one click costs nothing and neither
    //control depends on the event it is less sure of.
    ['input', 'change'].forEach(eventName => {
        document.addEventListener(eventName, (event) => {
            const voucherForm = event.target?.closest('[data-voucher-form]');
            if (!voucherForm)
            {
                return;
            }

            const amountField = voucherForm.querySelector('[data-voucher-amount]');

            //a preset writes its value into the amount field, so one number
            //decides the total rather than two sources competing over it
            if (amountField && event.target.closest('[data-voucher-amounts]'))
            {
                amountField.value = event.target.value;
            }

            //...and typing an amount clears the presets, since a preset left
            //checked would claim the visitor chose £50 while the field reads 75
            if (amountField && event.target === amountField)
            {
                voucherForm.querySelectorAll('[data-voucher-amounts] input:checked').forEach(preset => {
                    preset.checked = false;
                });
            }

            window.updateVoucherFormTotal(voucherForm);
        });
    });

    //monetary voucher form: Add to Basket. The <form> is a real one with a real
    //action, so the endpoint is stated once in the view and native validation
    //(min/max/required) runs before this ever fires.
    document.addEventListener('submit', async (event) => {
        const form = event.target?.closest('[data-voucher-form]');
        if (!form)
        {
            return;
        }

        //never a page reload: the basket is a panel, not a page
        event.preventDefault();

        const error = form.querySelector('[data-voucher-error]');
        const button = form.querySelector('[type="submit"]');

        const setError = (message) => {
            if (error)
            {
                error.textContent = message ?? '';
                error.hidden = !message;
            }
        };

        //the section is a CMS block and can be placed on a page with no basket
        //button to configure the store. Saying so beats a silent no-op
        if (!isBasketConfigured())
        {
            setError('The basket is unavailable on this page.');
            return;
        }

        //the click is already in flight - a second one would buy two
        if (form.dataset.voucherSubmitting === 'true')
        {
            return;
        }

        const amountField = form.querySelector('[data-voucher-amount]');
        const quantityField = form.querySelector('[data-voucher-quantity] input[type="number"]');

        form.dataset.voucherSubmitting = 'true';
        if (button)
        {
            button.disabled = true;
        }
        setError(null);

        const added = await addMonetaryVoucherToBasket({
            amount: Number(amountField?.value),
            //no stepper in the form means one of whatever was chosen, matching
            //the total handler above
            quantity: quantityField ? Number(quantityField.value) : 1,
        });

        form.dataset.voucherSubmitting = 'false';
        if (button)
        {
            button.disabled = false;
        }

        if (added)
        {
            openBasketPanel();
            return;
        }

        setError(basketState.basketError);
    });

    //newsletter sign-up. Delegated from the document like the voucher form above, and
    //here rather than inline in the section view for the reason set out in
    //docs/homepage-location-swap.md: the inline version bound its handler inside its own
    //DOMContentLoaded listener, which never fires for a section that arrives later, and an
    //inline <script> inserted with innerHTML never executes at all. The form fell silent
    //the moment the homepage's content was swapped for another spa's.
    //
    //Behaviour is otherwise the one the inline script had: post in the background, replace
    //the whole form with a thank-you on success, and show the server's own validation
    //message on a 422.
    document.addEventListener('submit', async (event) => {
        const form = event.target?.closest('[data-newsletter-form]');
        if (!form)
        {
            return;
        }

        event.preventDefault();

        const response = form.querySelector('[data-newsletter-response]');
        const button = form.querySelector('[data-newsletter-submit]');

        const setMessage = (html) => {
            if (response)
            {
                response.innerHTML = html ?? '';
            }
        };

        setMessage(null);
        if (button)
        {
            button.disabled = true;
        }

        try
        {
            const result = await fetch(form.action, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': form.querySelector('input[name="_token"]')?.value ?? window.csrfToken(),
                    'Accept': 'application/json',
                },
                body: new FormData(form),
            });

            if (result.ok)
            {
                //the form is replaced wholesale, so there is nothing left to re-enable
                form.outerHTML = '<p class="success-message">Thank you for subscribing!</p>';
                return;
            }

            if (result.status === 422)
            {
                const data = await result.json();
                //textContent via a text node rather than interpolated markup: the message
                //comes back from the server, and building HTML out of it is how a
                //validation message becomes an injection point
                const message = document.createElement('p');
                message.className = 'error-message';
                message.textContent = data.errors?.email?.[0] ?? 'Validation error';
                setMessage(null);
                response?.appendChild(message);
            }
            else
            {
                throw new Error('Something went wrong. Please try again.');
            }
        }
        catch (error)
        {
            const message = document.createElement('p');
            message.className = 'error-message';
            message.textContent = error.message;
            setMessage(null);
            response?.appendChild(message);
        }

        if (button)
        {
            button.disabled = false;
        }
    });

    document.addEventListener('mousedown',(event) => { //needs mousedown for close to stop accidental drags off modal closing it
        if (event.target)
        {
            //check for clicks inside closeable modal
            const modalOuters = document.querySelectorAll("aside.modal.closeable");

            modalOuters.forEach(modalOuter => {
                if (modalOuter.contains(event.target))
                {
                    const modalInner = modalOuter.querySelector(".modal_inner");
                    //closest() rather than checking the target itself: a press on the cross
                    //drawn inside a close button lands on its <svg>, not the button, and
                    //closed nothing
                    if (!modalInner.contains(event.target) || event.target.closest('.modal_close_button'))
                    {
                        window.hideModal();
                    }
                }
            });
        }
    });

    //hide on escape being pressed
    document.addEventListener("keyup", function(event) {
        if (event.key === "Escape") {
            const modals = document.querySelectorAll("aside.modal");
            modals.forEach(modal => {
                if (modal.classList.contains("visible"))
                {
                    window.hideModal();
                }
            });

            //Vue's panels handle their own Escape (topmost only - see
            //resources/js/shared/panelStack.js), so the attribute selector keeps this
            //to the panels this script owns
            const popOutPanels = document.querySelectorAll(".pop_out_panel[data-pop-out-panel-id]");
            popOutPanels.forEach(panel => {
                if (panel.classList.contains("visible"))
                {
                    window.hidePopOutPanel(panel.getAttribute('data-pop-out-panel-id'));
                }
            });
        }
    });

});